const DEFAULT_HIGHLIGHT_CLASS = 'highlighted-cell';
const DEFAULT_SCROLL_DELAY = 150;
const DEFAULT_SCROLL_BEHAVIOR = 'smooth';
const DEFAULT_SCROLL_BLOCK = 'center';
const DEFAULT_ID_FIELD = 'id';
const DEFAULT_TABLE_CLASS_NAME = 'table';
const DEFAULT_COLUMN_WIDTH = 'auto';
const DEFAULT_COLUMN_ALIGNMENT = 'left';
const EXPANDER_COLUMN_ID = 'expander';

export {
  DEFAULT_HIGHLIGHT_CLASS,
  DEFAULT_SCROLL_DELAY,
  DEFAULT_SCROLL_BEHAVIOR,
  DEFAULT_SCROLL_BLOCK,
  DEFAULT_ID_FIELD,
  DEFAULT_TABLE_CLASS_NAME,
  DEFAULT_COLUMN_WIDTH,
  DEFAULT_COLUMN_ALIGNMENT,
  EXPANDER_COLUMN_ID,
};
